import {Pile} from '@/models';

export default [
	{
		path: '/pile',
		name: 'pile',
		meta: {
			title: 'Liste des longueurs de vente',
			granted: [ 'API_GET_PILE' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Pile.vue')
	},
	{
		path: '/pile/edit/:id',
		name: 'pile-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Pile/Edit.vue'),
				class: Pile
			}),
		},
		meta: {
			title: 'Edition d\'une longueurs de vente',
			granted: [ 'API_PUT_PILE' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];